export default {
    install: (Vue) => {
        const req = require.context('../components/', true, /\.(js|vue)$/i);

        req.keys().map(key => { const name = key.match(/\w+/)[0]; return Vue.component(name, req(key).default) });
    }
}